module.exports = __webpack_public_path__ + "img/quartierWIR.4dd3190e.png";